export default "__VITE_ASSET__JE6eecr0B5KOWbFIO9yPFw__"